module.exports = __webpack_public_path__ + "20260508d160511t/img/production-pic.2a7c54ea.png";